module.exports = __webpack_public_path__ + "static/img/son4_active.b1ddb5a1.jpg";